const ISO_DATE_PREFIX = /^(\d{4}-\d{2}-\d{2})/;

export function formatAdminDate(value: string | Date | null | undefined): string {
    if (value == null || value === '') {
        return '—';
    }
    if (typeof value === 'string') {
        const match = value.match(ISO_DATE_PREFIX);
        if (match) {
            return match[1];
        }
    }
    const date = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(date.getTime())) {
        return '—';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function formatAdminDateTime(value: string | Date | null | undefined): string {
    if (value == null || value === '') {
        return '—';
    }
    const date = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(date.getTime())) {
        return '—';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}
